// Auto-logout constants
export const idleLogoutTime = 1000 * 60 * 10; //TODO Revert this counter to 10 min after testing on staging
export const WATCH_TIME_BUFFER = 10; // seconds buffer for watched time validation
export const STORAGE_KEYS = {
  LAST_TIMESTAMP: 'blue_lastTimeStamp',
  WATCHED_TIME: 'watched_time',
  USERNAME: 'blue_webusername'
} as const;
